import { Link } from "react-router-dom";
import { Mail, Clock, Ticket, Package, ArrowRight } from "lucide-react";
import InnerHero from "@/components/InnerHero";
import Reveal from "@/components/Reveal";
import { EMAIL, HORARIO, BUY_URL } from "@/data";

export default function Contacto() {
    return (
        <div data-testid="contacto-page">
            <InnerHero
                variant="dark"
                image="/images/familia-micro.webp"
                crumb="Contacto"
                title="Estamos para ayudarte"
                subtitle="Escribinos por email y te respondemos a la brevedad en nuestro horario de atención."
            />

            <section className="py-20 lg:py-28">
                <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                    <div className="grid gap-12 lg:grid-cols-2">
                        <Reveal>
                            <div>
                                <p className="text-xs font-bold uppercase tracking-[0.25em] text-brand">
                                    Escribinos
                                </p>
                                <a
                                    href={`mailto:${EMAIL}`}
                                    data-testid="contacto-email"
                                    className="mt-3 block font-display text-lg sm:text-3xl lg:text-4xl font-extrabold normal-case leading-tight tracking-tight text-ink break-words hover:text-brand"
                                >
                                    {EMAIL.split("@")[0]}
                                    <wbr />@{EMAIL.split("@")[1]}
                                </a>

                                <div className="mt-10 space-y-5">
                                    <div className="flex items-start gap-4">
                                        <span className="inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-brand-light text-brand">
                                            <Mail className="h-6 w-6" />
                                        </span>
                                        <div>
                                            <p className="text-xs font-bold uppercase tracking-wide text-ink/50">
                                                Email
                                            </p>
                                            <a
                                                href={`mailto:${EMAIL}`}
                                                className="text-base font-semibold text-ink hover:text-brand break-all"
                                            >
                                                {EMAIL}
                                            </a>
                                        </div>
                                    </div>
                                    <div className="flex items-start gap-4">
                                        <span className="inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-brand-light text-brand">
                                            <Clock className="h-6 w-6" />
                                        </span>
                                        <div>
                                            <p className="text-xs font-bold uppercase tracking-wide text-ink/50">
                                                Horario comercial
                                            </p>
                                            <p className="text-base font-semibold text-ink">
                                                {HORARIO}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Reveal>

                        <Reveal delay={0.12}>
                            <div className="space-y-5">
                                <a
                                    href={BUY_URL}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    data-testid="contacto-buy"
                                    className="group flex flex-col items-center gap-4 rounded-3xl bg-brand p-8 text-center text-white transition-transform hover:-translate-y-1 sm:flex-row sm:justify-between sm:text-left"
                                >
                                    <div>
                                        <div className="flex items-center justify-center gap-3 sm:justify-start">
                                            <Ticket className="h-6 w-6" />
                                            <h3 className="text-lg font-extrabold uppercase tracking-tight">
                                                Comprar pasajes
                                            </h3>
                                        </div>
                                        <p className="mt-2 text-sm text-white/85">
                                            Buscá origen, destino y fecha.
                                        </p>
                                    </div>
                                    <ArrowRight className="h-6 w-6 shrink-0 transition-transform group-hover:translate-x-1.5" />
                                </a>

                                <Link
                                    to="/encomiendas"
                                    data-testid="contacto-encomiendas"
                                    className="group flex flex-col items-center gap-4 rounded-3xl border border-black/10 bg-white p-8 text-center text-ink transition-transform hover:-translate-y-1 sm:flex-row sm:justify-between sm:text-left"
                                >
                                    <div>
                                        <div className="flex items-center justify-center gap-3 sm:justify-start">
                                            <Package className="h-6 w-6 text-brand" />
                                            <h3 className="text-lg font-extrabold uppercase tracking-tight">
                                                Encomiendas
                                            </h3>
                                        </div>
                                        <p className="mt-2 text-sm text-ink/60">
                                            Seguí el estado de tu envío.
                                        </p>
                                    </div>
                                    <ArrowRight className="h-6 w-6 shrink-0 text-brand transition-transform group-hover:translate-x-1.5" />
                                </Link>
                            </div>
                        </Reveal>
                    </div>
                </div>
            </section>
        </div>
    );
}
